import * as angular from 'angular';
import * as _ from 'lodash';

import {
    ICurrentApplicationService,
    IRolesService,
    IApprovalStrategyService,
    IapplicationUserService,
    IUserGroupsService
} from '..';
import { superAdminRole } from '../../common';
import { MixedUserChoice, UserType } from '../../models/mailing/MixedUserChoice';
import { IRecipientsComponentViewModel } from './IRecipientsComponentViewModel';

export interface IRecipientsHelper {
    loadRecipients(approvalStrategyGuid?: string, isEvent?: boolean): angular.IPromise<IRecipientsComponentViewModel>;
}

export class RecipientsHelper implements IRecipientsHelper {

    static serviceId = 'recipientsHelper';
    static $inject = [
        'applicationUserService',
        'currentApplicationService',
        'rolesService',
        'approvalStrategyService',
        'userGroupsService',
        '$translate'
    ];

    constructor(
        private _applicationUserService: IapplicationUserService,
        private _currentApplicationService: ICurrentApplicationService,
        private _rolesService: IRolesService,
        private _approvalStrategyService: IApprovalStrategyService,
        private _userGroupsService : IUserGroupsService,
        private _translateService: angular.translate.ITranslateService
    ) { }

    loadRecipients(approvalStrategyGuid?: string, isEvent: boolean = false): angular.IPromise<IRecipientsComponentViewModel> {
        const keywords = isEvent ? ['Creator', 'Assignee'] : [];
        const result: IRecipientsComponentViewModel = {
            users: [],
            roles: [],
            levels: [],
            userGroups: [],
            keywords,
            choices: []
        };
        const currentAppGuid = this._currentApplicationService.getApplicationConfiguration().guid;
        const levelPrefix = this._translateService.instant('Level').substr(0, 1);
        // let emailUsers: string[];



        //todo integrate
        return this._rolesService
            .getAll()
            .then(roles => {
                result.roles = roles.filter(d => d.name.toLowerCase() !== superAdminRole);                 
                return this._applicationUserService.getUsers(currentAppGuid);
            })
            .then(users => {
                result.users = users.filter(u => !!u.email);
                return this._approvalStrategyService.getAll();
            })
            .then(strategies => {
                // filter strategies if arg is provided
                if (approvalStrategyGuid) {
                    strategies = strategies.filter(s => s.guid === approvalStrategyGuid);
                }
                result.levels = _.chain(strategies.map(s => s.approbationStrategyLevelCollection))
                    .flatten()
                    .map(sl => sl.level)
                    .uniq()
                    .sortBy()
                    .value();
                    return this._userGroupsService.getAll();
            })
            .then(userGroups => {
                result.userGroups = userGroups.map(g=> { return {name : g.name, id: g.guid }; });
            })
            .then(() => {
                // build VM for all available choices in dropdown
                result.choices = []
                    .concat(result.users.map(u => {
                        const result: MixedUserChoice = {
                            name: u.name,
                            type: UserType.User,
                            originalObject: u
                        };
                        return result;
                    }))
                    .concat(result.roles.map(r => {
                        const result: MixedUserChoice = {
                            name: r.name,
                            type: UserType.Role,
                            originalObject: r
                        };
                        return result;
                    }))
                    .concat(result.levels.map(l => {
                        const result: MixedUserChoice = {
                            name: `${levelPrefix}${l + 1}`,
                            type: UserType.Level,
                            originalObject: l
                        };
                        return result;
                    }))
                    .concat(result.keywords.map(l => {
                        const result: MixedUserChoice = {
                            name: l,
                            type: UserType.Keyword,
                            originalObject: l.toLowerCase()
                        };
                        return result;
                    }))
                    .concat(result.userGroups.map(g => {
                        const result: MixedUserChoice = {
                            name: g.name,
                            type: UserType.UserGroup,
                            originalObject: g
                        };
                        return result;
                    }))                  
                    ;
                return result;
            });
    }
}